import { HttpStatus } from '@d-id/http-status';
import { getSsml } from '@d-id/ssml';
import { ApiError, VoiceConfig } from '@d-id/types';
import axios from 'axios';

const fileFormat = 'mp3';
const azureTtsOutputformat = 'audio-24khz-48kbitrate-mono-mp3';
//const azureVoicesEndpoint = 'https://westus2.tts.speech.microsoft.com/cognitiveservices/voices/list';
const azureTtsEndpoint = 'https://westus3.tts.speech.microsoft.com/cognitiveservices/v1';
export const MAX_TEXT_LENGTH_MICROSOFT = 3875;

export async function createTextToSpeech(
    text: string,
    voiceId: string,
    azureTtsKey: string,
    voiceConfig?: VoiceConfig
) {
    validateMicrosoftTtsText(text);
    let response;
    const maxAttempts = 3;
    for (let attempt = 0; attempt <= maxAttempts; attempt++) {
        try {
            response = await axios.post(azureTtsEndpoint, getSsml(text, voiceId, voiceConfig), {
                responseType: 'arraybuffer',
                timeout: 10 * 1000,
                headers: {
                    'Ocp-Apim-Subscription-Key': azureTtsKey,
                    'Content-Type': 'application/ssml+xml',
                    'X-Microsoft-OutputFormat': azureTtsOutputformat,
                },
            });
            break;
        } catch (error) {
            if (attempt === maxAttempts) {
                throw error;
            }
        }
    }

    const data = response?.data?.toString('base64');
    const contentType = response?.headers?.['content-type'];

    if (!data || !contentType) throw new ApiError('InvalidText', 400, 'No data returned from Microsoft tts');

    return {
        data: `data:audio/mpeg;base64,${data}`,
        contentType,
        outputFormat: fileFormat,
    };
}

function validateMicrosoftTtsText(text: string): void {
    if (text.length > MAX_TEXT_LENGTH_MICROSOFT) {
        throw new ApiError(
            'TextTooLong',
            HttpStatus.PAYLOAD_TOO_LARGE,
            `Text is too long. got ${text.length} characters, max is ${MAX_TEXT_LENGTH_MICROSOFT}`
        );
    }
}
